import type { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import usePaidByBankFinished from './usePaidByBankFinished';

const PaidByBankFinished: FunctionComponent = () => {
  const { subtitle } = usePaidByBankFinished();
  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="This job is complete & signed-off"
      labelLine1={subtitle}
    />
  );
};

export default PaidByBankFinished;
